import * as $ from 'jquery';

export class Breadcrumb {

  protected $breadcrumb = $('.breadcrumb-menu');
  protected breadcrumbItems: number = $('.breadcrumb-menu .breadcrumb-menu__item--collapsible').length;
  protected breadcrumbItemsWidth: number[] = [];

  constructor() {
    if (this.$breadcrumb) {

      // get Width of all Breadcrumb-Items and save them in Array
      $('.breadcrumb-menu .breadcrumb-menu__item--collapsible').each((i, item) => {
        this.breadcrumbItemsWidth[i] = item.offsetWidth;
      });

      // if Breadcrumb is visible (not Mobile) call resizeBreacrumbElements-Function
      if ($('.breadcrumb').is(':visible')) {
        this.resizeBreadcrumbElements(0);
      }

      $(window).resize(() => {
        if ($('.breadcrumb').is(':visible')) {
          this.resizeBreadcrumbElements(0);
        }
      });
    }
  }

  protected resizeBreadcrumbElements(itemIndex: number) {
    let breadcrumbWidth: number = 0;
    let windowWidth: number;

    // get current BreadcrumbWidth from width of all childs
    this.$breadcrumb.children().each((i, item) => {
      breadcrumbWidth += item.offsetWidth;
    });

    // determine maxWidth available for Breadcrumb
    let breadcrumbMaxWidth = this.$breadcrumb.width() || 0;
    windowWidth = breadcrumbMaxWidth - 80;

    // count shrinked Elements, set ItemIndexShrinked - 1 for ArrayIndex
    let BreadcrumbItemsShrinked = $('.breadcrumb-menu .breadcrumb-menu__item--shrink').length;
    let ItemIndexShrinked = BreadcrumbItemsShrinked - 1;

    // check width of Breadcrumb to shrink Items or else show them again
    if (this.breadcrumbItems >= itemIndex && breadcrumbWidth > windowWidth) {
      this.shrinkBreadcrumbItem(itemIndex);
      itemIndex++;

      this.resizeBreadcrumbElements(itemIndex);

    } else if (BreadcrumbItemsShrinked >= 1 && breadcrumbWidth < windowWidth) {
      let widthItemTemp = breadcrumbWidth + this.breadcrumbItemsWidth[ItemIndexShrinked];

      if (widthItemTemp < windowWidth) {
        this.enlargeBreadcrumbItem(ItemIndexShrinked);
        ItemIndexShrinked = ItemIndexShrinked - 1;
      }
    }
  }

  protected shrinkBreadcrumbItem(itemIndex: number) {
    let $item = $('.breadcrumb-menu .breadcrumb-menu__item--collapsible').eq(itemIndex);
    $item.attr('title', $item.text().trim()).addClass('breadcrumb-menu__item--shrink');
  }

  protected enlargeBreadcrumbItem(ItemIndexShrinked: number) {
    $('.breadcrumb-menu .breadcrumb-menu__item--shrink').eq(ItemIndexShrinked).removeAttr('title').removeClass('breadcrumb-menu__item--shrink');
  }
}
